export default "__VITE_ASSET__CPpA2pek__"